<template>
  <div class="create-contact-options">
    <div class="contact-option" :class="{'selected': currentOption === 'sms'}" @click="onChooseOption('sms')"><span><fa-icon icon="sms" fixed-width/> SMS </span></div>
    <div class="contact-option" :class="{'selected': currentOption === 'email'}" @click="onChooseOption('email')"><span><fa-icon icon="envelope"  fixed-width /> Email</span></div>
<!--    <div class="contact-option" :class="{'selected': currentOption === 'whatsapp'}" @click="onChooseOption('whatsapp')"><span><fa-icon :icon="['fab', 'whatsapp']"  fixed-width/> WhatsApp</span></div>-->
    <div class="contact-option" :class="{'selected': currentOption === 'link'}" @click="onChooseOption('link')"><span><fa-icon icon="link"  fixed-width /> Link</span></div>
  </div>
</template>

<script>
  export default {
    name: 'CreateContactOption',
    props: {
      currentOption: {
        type: String
      }
    },

    methods: {
      onChooseOption(option) {
        this.$emit('optionChosen', option)
      }
    }
  }
</script>

<style lang="scss">
@import "CreateContactOption";
</style>
